import React from 'react'
import { useReveal } from '../hooks/useReveal'

function Reveal({ children, delay = 0, direction = 'up', className = '', as: Tag = 'div', ...rest }) {
  const [ref, visible] = useReveal()
  return (
    <Tag
      ref={ref}
      className={`reveal reveal-${direction} ${visible ? 'is-visible' : ''} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
      {...rest}
    >
      {children}
    </Tag>
  )
}

export default Reveal
